import { render, staticRenderFns } from "./PreDetail.vue?vue&type=template&id=faf868f2&scoped=true"
import script from "./PreDetail.vue?vue&type=script&lang=js"
export * from "./PreDetail.vue?vue&type=script&lang=js"
import style0 from "./PreDetail.vue?vue&type=style&index=0&id=faf868f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf868f2",
  null
  
)

export default component.exports